import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Box, Text, VStack } from '@chakra-ui/react';

import { selectCompanyFeatures } from '../../../redux/modules/company';
import { createMap } from '../../../utils/arrayUtil';
import SearchAdvancedFilter from '../SearchAdvancedFilter';

const AdvancedFilters = ({ searchBlueprint }) => {
  const advancedFilters = useSelector(searchBlueprint.selectAdvancedFilters);
  const stagedFilter = useSelector(searchBlueprint.selectStagedFilter);
  const companyFeatures = useSelector(selectCompanyFeatures);
  const companyFeaturesMap = useMemo(() => createMap(companyFeatures, 'name'), [companyFeatures]);

  return (
    <Box>
      <Text color="greyScale.700" mb={4} mt={8}>Advanced Filters</Text>
      <VStack spacing={4}>
        {
          advancedFilters
            .filter(filter => (filter.featureFlag ? companyFeaturesMap[filter.featureFlag].isEnabled : true))
            .map((filter, index) => (
              <SearchAdvancedFilter
                filter={filter}
                index={index}
                key={index}
                searchBlueprint={searchBlueprint}
              />
            ))
        }
        <SearchAdvancedFilter
          isActive
          filter={stagedFilter}
          searchBlueprint={searchBlueprint}
        />
      </VStack>
    </Box>
  );
};

export default AdvancedFilters;
